// @flow
import { filter, sortBy } from 'lodash';

import type {
  Action, FaqCategory, FaqQuestion, State
} from '../types';

import {
  FETCH_FAQ_CATEGORIES,
  FETCH_FAQ_CATEGORIES_SUCCESS,
  FETCH_FAQ_CATEGORY_QUESTIONS_SUCCESS
} from './constants';

const initialState: State = {
  requesting: false,
  employerCategories: [],
  employeeCategories: [],
  questionsByCatSlug: {}
};

const reducer = (state: State = initialState, action: Action) => {
  switch (action.type) {
    case FETCH_FAQ_CATEGORIES:
      return {
        ...state,
        requesting: true
      };

    case FETCH_FAQ_CATEGORIES_SUCCESS: {
      const sorted: Array<FaqCategory> = sortBy(action.data, ['attributes.position']);
      return {
        ...state,
        requesting: false,
        employeeCategories: filter(sorted, { attributes: { kind: 'employees' } }),
        employerCategories: filter(sorted, { attributes: { kind: 'employers' } })
      };
    }

    case FETCH_FAQ_CATEGORY_QUESTIONS_SUCCESS: {
      const sorted: Array<FaqQuestion> = sortBy(action.data, ['attributes.position']);

      return {
        ...state,
        questionsByCatSlug: {
          ...state.questionsByCatSlug,
          [action.categorySlug]: sorted
        }
      };
    }

    default:
      return state;
  }
};

export default reducer;
